import React, { useState } from 'react';
import { Avatar } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useUser } from 'services/providers/UserProvider';

const AvatarUser = () => {
  const { logout } = useUser();
  const [hovered, setHovered] = useState(false);

  return (
    <Avatar
      size={32}
      icon={hovered ? <LogoutOutlined /> : <UserOutlined />}
      style={{ margin: '0px', cursor: 'pointer' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => logout()}
    />
  );
};

export default AvatarUser;
